// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"J1-z","displaySixCardTiles":"K1-z"};